import React from 'react';

const TaglineBanner = () => {
  return (
    <section className="mx-auto mt-8 max-w-7xl section-image-bg rounded-xl bg-green-50">
      <div className="relative min-h-[250px] overflow-hidden">

        <div className="absolute w-full inset-0 bg-gradient-to-r from-lime-50 from-15% via-lime-50/90 via-30% to-transparent to-70%" />

        <div className="relative z-10 max-w-lg px-8 py-10 md:px-12">
          <h2 className="text-xl font-bold leading-snug text-green-800 md:text-2xl">
            Together, we build a Stronger Rural Philippines
          </h2>

          <p className="mt-5 text-base leading-7 text-gray-700">
            Empowered farmers.
            <br />
            Resilient communities.
            <br />
            Sustainable future.
          </p>
        </div>

        <div className="hidden absolute bottom-5 left-1/2 z-20 flex -translate-x-1/2 gap-2">
          <button className="h-3 w-3 rounded-full bg-green-700" />
          <button className="h-3 w-3 rounded-full bg-white" />
          <button className="h-3 w-3 rounded-full bg-white" />
        </div>
      </div>
    </section>
  );
};

export default TaglineBanner;